import { motion } from "framer-motion";
import { Clock3, MapPinned, ShieldCheck, ReceiptText } from "lucide-react";

const ITEMS = [
  { icon: Clock3, title: "7/24 Kesintisiz Hizmet", text: "Gece, gündüz, hafta sonu ve bayramlarda nöbettayız." },
  { icon: MapPinned, title: "Hızlı Ulaşım", text: "Merkez ilçelerde ortalama 15-20 dakikada yanınızdayız." },
  { icon: ShieldCheck, title: "Hasarsız Taşıma", text: "Aracınız sabitlenerek güvenle taşınır; teslimde sürpriz olmaz." },
  { icon: ReceiptText, title: "Şeffaf Fiyat", text: "Fiyatı telefonda netleştiririz; yolda sürpriz olmaz." },
];

export default function TrustBar() {
  return (
    <section data-testid="trust-bar" className="py-14 lg:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {ITEMS.map(({ icon: Icon, title, text }, i) => (
          <motion.div
            key={title}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.55, delay: i * 0.08 }}
            data-testid={`trust-item-${i}`}
            className="rounded-2xl border border-white/10 bg-night-800/60 p-6 hover:border-brand/50 transition-colors duration-300"
          >
            <Icon className="w-7 h-7 text-brand" strokeWidth={2.2} />
            <h3 className="font-display font-bold uppercase text-xl mt-4 text-white">{title}</h3>
            <p className="text-sm text-slate-400 mt-2 leading-relaxed">{text}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
